import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  Badge,
  CardContent,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { badgesKyc } from "../custom/BadgesKyc";
import * as actions from "../actions";
import PageContainer, { CardPageItem } from "../custom/Page";
import HeaderPageItem from "../custom/HeaderPageItem";
import { ChevronRight } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";
import { generateSumsubSDK } from "../actions/Kyc";
import {
  checkStatusUntilFinal,
  getLastSumsubKYC,
  isSumsubApprovedOrAnalyzing,
} from "../util/Sumsub";

class CustomerSumsubValidation extends Component {
  state = {
    pj: this.props.currentUser.isPj,
  };

  loadKyc = () => {
    actions.getKyc().then((data) => {
      const userKyc = data;
      this.setState({ userKyc });
    });
  };

  componentDidMount() {
    this.props.getMe();
    this.loadKyc();
    this.props.getConfig();
  }

  handleOpenSumsubKYC = async () => {
    let popup;
    try {
      const lastKyc = getLastSumsubKYC(this.state.userKyc);
      if (isSumsubApprovedOrAnalyzing(lastKyc)) {
        const { showErrorMessage } = this.props;
        return showErrorMessage(
          lastKyc?.status.toLowerCase() === "approved"
            ? "app.kyc.approved"
            : "app.kyc.analyzing"
        );
      }
      popup = window.open("");
      const result = await generateSumsubSDK();
      popup.location.href = result.url;
      await checkStatusUntilFinal(popup, () => {
        this.loadKyc();
        this.props.getMe();
      });
    } catch (e) {
      if(popup) {
        popup.close();
      }
      const { showErrorMessage } = this.props;
      showErrorMessage(e?.response?.data?.message ?? e?.message ?? e);
    }
  };

  render() {
    const { currentUser, consultant, config } = this.props;
    const { pj, userKyc } = this.state;
    const badges = badgesKyc(pj, userKyc, config.isSumsubKYCEnabled, currentUser.isSecondary);

    if (!currentUser) {
      return <CircularProgress style={{ marginTop: "25%" }} />;
    }

    return (
      <PageContainer>
        <HeaderPageItem
          title="app.settings.title"
          showBackButton
          destination="/dashboard"
        />
        <CardPageItem>
          <CardContent>
            {badges.cor == "error" ? (
              <Typography gutterBottom variant="subtitle1">
                <FormattedMessage id="app.documents.badge.error.title" />
              </Typography>
            ) : badges.cor == "primary" ? (
              <Typography gutterBottom variant="subtitle1">
                <FormattedMessage id="app.documents.badge.primary.title" />
              </Typography>
            ) : !consultant && currentUser.role !== "AGENT" ? (
              <Typography gutterBottom variant="body1">
                <FormattedMessage id="app.documents.noAgent.title" />
              </Typography>
            ) : (
              <Typography gutterBottom variant="body1">
                <FormattedMessage id="app.documents.update.title" />
              </Typography>
            )}
          </CardContent>
          <CardContent>
            <List>
              <ListItem button onClick={this.handleOpenSumsubKYC}>
                <ListItemText
                  primary={<FormattedMessage id="app.validateIdentity" />}
                />
                <Badge badgeContent={badges.qtd} color={badges.cor}>
                  <ChevronRight color="action" />
                </Badge>
              </ListItem>
            </List>
          </CardContent>
        </CardPageItem>
      </PageContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    config: state.config,
    currentUser: state.user.user.me,
    consultant: state.user.user.me.consultant,
  };
}

export default compose(connect(mapStateToProps, actions))(
  CustomerSumsubValidation
);
